/// <reference path="../../../typedefs/dash.js" />

import { path, pathOr, hasPath } from 'ramda'
import { UNASSIGNED_PANEL_PART } from 'components/SwitchAndGauge/definitions/dashConstants'

/**
 * Create a rule key for the rule group object to select.
 * @param {string[]} rules
 * @returns {string}
 */
const createSpecificRuleKey = (rules) => rules.join('--')

/**
 * A selector function to return specific rules by selector key.
 *
 * @param {{'rule--selector--key': Rule[]}} rules
 * @param {string} key
 * @param {string} specificRule
 * @returns {Rule[]} rules
 */
export const rulesSelector = (rules, key, specificRule) => {
  // look for a specific rule
  if (hasPath([key, specificRule], rules)) {
    return path([key, specificRule], rules)
  }

  // apply any default rules for the key
  return pathOr([], [key, 'defaults'], rules)
}

/**
 * A selector function to return specific rules for the "type" selector key.
 *
 * @param {{'rule--selector--key': Rule[]}} rules
 * @param {string} key
 * @param {string} specificRule
 * @returns {Rule[]} rules
 */
export const typeRulesSelector = (rules, key, specificRule) => {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < specificRule.length; i++) {
    const selectors = specificRule.slice(i)
    const specificRuleKey = createSpecificRuleKey(selectors)
    if (hasPath([key, specificRuleKey], rules)) {
      return path([key, specificRuleKey], rules)
    }
  }

  // for each value in rule key
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < specificRule.length; i++) {
    if (hasPath([key, specificRule[i]], rules)) {
      return path([key, specificRule[i]], rules)
    }
  }

  // apply any default rules for the key
  return pathOr([], [key, 'defaults'], rules)
}

/**
 * A selector function to return specific rules for locations.
 *
 * @param {{'rule--selector--key': Rule[]}} rules
 * @param {string} key
 * @param {string} specificRule
 * @returns {Rule[]} rules
 */
export const locationRulesSelector = (rules, key, specificRule) => {
  // look for a specific rule
  const [locationName, componentType] = specificRule

  // unassigned locations
  if (locationName.includes(UNASSIGNED_PANEL_PART)) {
    if (hasPath([key, `${UNASSIGNED_PANEL_PART}--${componentType}`], rules)) {
      return path([key, `${UNASSIGNED_PANEL_PART}--${componentType}`], rules)
    }

    if (hasPath([key, UNASSIGNED_PANEL_PART], rules)) {
      return path([key, UNASSIGNED_PANEL_PART], rules)
    }
  }

  // apply any default rules for the key
  return pathOr([], [key, 'defaults'], rules)
}
